/**
 * Tabellenbuch-Sprint — pure Auswertung (CLAUDE.md Regel 5:
 * täglich 5 min Navigation mit Stoppuhr, Ziel < 30 s pro Begriff).
 */
export const SPRINT_TARGET_MS = 30_000;
export const SPRINT_DURATION_MS = 300_000;

export interface SprintEntry {
  cardId: string;
  ms: number;
}

export interface SprintSummary {
  count: number;
  avgMs: number;
  underTarget: number;
  underTargetPct: number;
}

export function sprintSummary(entries: readonly SprintEntry[]): SprintSummary {
  const count = entries.length;
  if (count === 0) return { count: 0, avgMs: 0, underTarget: 0, underTargetPct: 0 };
  const totalMs = entries.reduce((s, e) => s + e.ms, 0);
  const underTarget = entries.filter((e) => e.ms < SPRINT_TARGET_MS).length;
  return {
    count,
    avgMs: Math.round(totalMs / count),
    underTarget,
    underTargetPct: underTarget / count,
  };
}
